











import { Component, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import FiatTrade from "trade/components/fiat_trade/Index.vue";
import Introduction from "trade/components/fiat_trade/Introduction.vue";
import { ERROR } from "trade/constants";
import mixins from "@/mixins";
import utils from "trade/utils";

@Component({
  components: {
    FiatTrade,
    Introduction
  }
})
class C2CPage extends Mixins(mixins.page) {
  @Getter("trade/getFiatAssets") wantedAssets;

  submitting = false;

  get title() {
    return this.$t("trade.c2c") as string;
  }

  mounted() {
    this.$store.dispatch("trade/loadData");
  }

  async handlePutOrder(data) {
    this.submitting = true;
    try {
      const order = await this.$api.market.putC2COrder({
        amount: data.fiatValue,
        fiat: data.fiatAssetId,
        asset: data.wantedAssetId
      });
      this.$helper.toFusionPath(this, "trade", {
        name: "orders-fiat-id",
        params: { id: order.id + "" }
      });
    } catch (error) {
      if (error.code === ERROR.OTC_KYC_ERROR) {
        utils.order.showKycErrorModal(this);
      } else {
        this.$common.utils.helper.errorHandler(this, error);
      }
    }
    this.submitting = false;
  }
}
export default C2CPage;
